import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    whiteSpace: 'nowrap',

    '& .shield': {
      marginLeft: '0.25rem',
      color: theme.palette.primary.main,
      width: '0.75rem',
      height: '0.75rem'
    },

    '& .alert': {
      marginLeft: '0.25rem',
      color: theme.palette.indicator.red,
      width: '0.75rem',
      height: '0.75rem'
    },

    '& .more': {
      marginLeft: '0.25rem',
      color: theme.palette.primary.main,
      cursor: 'default'
    }
  },

  tooltip: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '0.375rem',
    fontSize: theme.size.sm,

    '& .row': {
      display: 'flex',
      alignItems: 'center'
    },

    '& .icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '0.25rem',
      width: '0.75rem',
      height: '0.75rem'
    },

    '& > :not(:last-child)': {
      marginBottom: '0.25rem'
    }
  },

  more: {
    marginLeft: '0.25rem',
    color: theme.palette.primary.main,
    cursor: 'default'
  }
}))

export default useStyles
